module.exports = __webpack_public_path__ + "static/img/1a (5).6ce5d57e.png";